<template>
  <div v-if="hotTopics.length > 0">
    <h6>🔥 微博热搜</h6>
    <div class="sidebar-box">
      <ol>
        <li v-for="(topic, index) in hotTopics" :key="index">
          <a
            :href="
              'https://s.weibo.com/weibo?q=%23' + topic.name + '%23&Refer=index'
            "
            target="_blank"
          >
            {{ topic.name }}
          </a>
        </li>
      </ol>
      <el-button style="width:100%" size="small" @click="goToWeibo"
        >查看全部 >></el-button
      >
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      hotTopics: [],
      timer: ""
    };
  },
  mounted: function() {
    this.getHotTopics();
    this.timer = setInterval(this.getHotTopics, 3600000);
  },
  methods: {
    getHotTopics: function() {
      this.$axios.get("/hotTopics").then(response => {
        this.hotTopics = response.data.slice(0, 5);
      });
    },
    goToWeibo: function() {
      window.open("https://s.weibo.com/top/summary?cate=realtimehot");
    }
  },
  beforeDestroy() {
    clearInterval(this.timer);
  }
};
</script>
